import { render, staticRenderFns } from "./no_intention.vue?vue&type=template&id=65565817&scoped=true"
import script from "./no_intention.vue?vue&type=script&lang=js"
export * from "./no_intention.vue?vue&type=script&lang=js"
import style0 from "./no_intention.vue?vue&type=style&index=0&id=65565817&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65565817",
  null
  
)

export default component.exports